export default {
	tilbakeTilElevUdirNo: "Gå tilbake til elev.udir.no",
	loggUt: "Logg ut",
	nonRecoverableError: {
		sporLaerer: `Rekk opp hånda og spør lærer om hjelp.`,
		tilLaerer: `Til lærer`,
		feilbeskrivelse: `Det har oppstått en feil i systemet som gjør at eleven ikke får se prøven. 
			Saken kan følges opp via tjenestevei.`
	},
	unknownOrRecoverableError: {
		sporAnsvarlig: `Rekk opp hånda og spør lærer om hjelp.`,
		forsokAGaaInnPaaProvenPaaNytt: `Forsøk å gå inn på prøven på nytt.`,
		tilLaerer: "Til lærer",
		feilbeskrivelseForLaerer: `Det har oppstått en feil i systemet som gjør at eleven ikke får se
			prøven. Eleven kan forsøke å gå inn på prøven på nytt.`,
		dersomFeilenVedvarer: `Dersom det ikke løser problemet, be lærer om hjelp.`,
		tilbakeTilGjennomforingKnapp: `Gå til prøven`
	},
	ikkePameldtError: {
		tittel: "Ikke påmeldt til prøve",
		content: "Du er ikke meldt på til en prøve. Si ifra til læreren din"
	}
};
